import React from "react";

export default function PaymentPageLogo() {
  return (
    <img
      src="/new-logo/logo.png"
      alt="Innlead"
      className="mx-auto block h-10 w-auto opacity-100"
      style={{ filter: "none" }}
    />
  );
}

export function PaymentEyebrow({
  children,
  tone = "brand",
}: {
  children: React.ReactNode;
  tone?: "brand" | "muted";
}) {
  const color = tone === "muted" ? "#565758" : "#5c7af7";
  return (
    <p
      className="text-xs font-semibold uppercase tracking-[0.14em]"
      style={{ color }}
    >
      {children}
    </p>
  );
}
